<template>
  <PrintPageLandscape :page-number="pageNumber" :page-count="pageCount">
    <PresentationCover>
      <template #corner><i>e way</i></template>

      <p class="presentation-cover__eyebrow">Rechtliche Dokumente</p>

      <h1 class="presentation-cover__title">
        Muster — beschränkte<br />
        persönliche Dienstbarkeit
      </h1>

      <div class="presentation-cover__accent" aria-hidden="true"></div>

      <p class="presentation-cover__subtitle">
        Eintragung im Grundbuch zugunsten der finanzierenden Bank — Standard-Mustervertrag zur
        Sicherung von Energiegewinnungsanlagen auf fremden Grundstücken.
      </p>

      <div class="presentation-cover__chapter-steps">
        <div
          v-for="step in documentSteps"
          :key="step.label"
          class="presentation-cover__chapter-step"
        >
          <i
            :class="['fa', step.icon, 'presentation-cover__chapter-step-icon']"
            aria-hidden="true"
          ></i>
          <span>{{ step.label }}</span>
        </div>
      </div>
    </PresentationCover>
  </PrintPageLandscape>
</template>

<script>
import PrintPageLandscape from '@/components/Print/PrintPageLandscape.vue';
import PresentationCover from '@/views/MasterPresentation/PresentationCover';

export default {
  name: 'MasterPresentationPrintPage44',
  components: { PrintPageLandscape, PresentationCover },
  props: {
    project: { type: Object, default: null },
    pageCount: { type: Number, default: null },
    pageNumber: { type: Number, default: 0 },
  },
  data() {
    return {
      documentSteps: [
        { icon: 'fa-file-text-o', label: 'Antrag Grundbuchamt' },
        { icon: 'fa-university', label: 'Eintragung Bank' },
        { icon: 'fa-pencil-square-o', label: 'Notarielle Beurkundung' },
      ],
    };
  },
};
</script>
